var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"500e6e5965aeead05deaa420225500fa3e290047"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["academy@klaviyo-1"]={id:"500e6e5965aeead05deaa420225500fa3e290047"};
      